// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","block":"QiwOvjJFqMSC","passengers":"_2rTrAuj1DCYB","passengers_readonly":"_15V7ZRhSuIin"};